<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.jushuitanAfterSale')"
    resource="jushuitan_after_sales"
    index-exec-filter-router-type="push"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/jushuitan_after_sales.js';
import { filterColumnsExtend as customerFilterColumnsExtend } from '../admin_grapes/customers.js';
import { AFTER_SALE_STATUS } from '@/constants';
import _ from 'lodash';
import { abilityService } from 'beans-admin-plugin';
import { displayText } from '@/custom_models_extend';

@Component
export default class JushuitanAfterSales extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        key: 'status_in',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            options: _.map(AFTER_SALE_STATUS, (key, value) => ({ label: key, value }))
          }
        }
      },
      'outer_as_id_cont',
      'so_id_cont',
      'shop_id_eq',
      'order_o_id_eq',
      {
        key: 'created_gteq_date',
        label: `${this.$t('jushuitanAfterSale.created')}${this.$t('gteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'created_lteq_date',
        label: `${this.$t('jushuitanAfterSale.created')}${this.$t('lteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'confirm_date_gteq',
        label: `${this.$t('jushuitanAfterSale.confirmDate')}${this.$t('gteqDatetime')}`,
      },
      {
        key: 'confirm_date_lteq',
        label: `${this.$t('jushuitanAfterSale.confirmDate')}${this.$t('lteqDatetime')}`,
      },
      'customer_id_eq',
      {
        key: 'order_user_id_not_null',
        label: '是否关联业务员',
      },
      abilityService.can('users.read_options') && 'customer_user_id_eq',
      {
        key: 'customer_customer_source_id_eq',
        prop: 'customer_customer_source_id_in',
        renderCell: {
          props: {
            multiple: true,
          }
        }
      },
      'customer_customer_level_id_eq',
      'customer_customer_tags_id_eq',
      {
        ...customerFilterColumnsExtend(['customer_business_models_id_eq'])[0],
        prop: 'customer_customer_business_models_id_eq',
      },
      {
        prop: 'related',
        label: '是否相关',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: true, label: this.$t('bean.yes') },
              { value: false, label: this.$t('bean.no') }
            ]
          }
        }
      }
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'as_id',
      'outer_as_id',
      'so_id',
      {
        key: 'status',
        renderCell(h, { props: { value } }) {
          return <span>{AFTER_SALE_STATUS[value]}</span>
        }
      },
      {
        prop: 'order.customer',
        label: this.$t('jushuitanOrder.customer'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'customers.show', params: { id: value.id } }}>{displayText(value)}</bean-link>
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'order.user',
        label: this.$t('jushuitanOrder.user'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'users.show', params: { id: value.id } }}>{displayText(value)}</bean-link>
          } else {
            return <span>/</span>
          }
        },
      },
      'modified',
      'confirm_date',
      'order',
      'shop',
      'refund',
      'real_refund',
      'receivable_amount',
      'received_amount',
      'payment',
      type === 'show' && {
        key: 'items',
        renderCell: (h, { props: { value } }) => {
          return <bean-table height={null} value={value} columns={[{
            prop: 'name',
            label: '商品名称',
          }, {
            prop: 'pic',
            label: '图片',
            renderCell(h, { props: { value } }) {
              return <el-image style="width: 100px; height: 100px" src={value} fit="contain" preview-src-list={[value]}  />
            }
          }, {
            prop: 'price',
            label: '单价',
          }, {
            prop: 'qty',
            label: '数量',
          }, {
            prop: 'amount',
            label: '总额',
          }, {
            prop: 'properties_value',
            label: '属性',
          }]} />
        },
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'jushuitan_after_sales.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'jushuitan_after_sales.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query }));
      } else {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) }));
      }
      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>,
    ]
  }
}

export const route = [
  {
    path: '/jushuitan_after_sales',
    name: 'jushuitan_after_sales.index',
    component: JushuitanAfterSales,
    props: {
      type: 'index',
    }
  },
  {
    path: '/jushuitan_after_sales/new',
    name: 'jushuitan_after_sales.new',
    component: JushuitanAfterSales,
    props: {
      type: 'new',
    }
  },
  {
    path: '/jushuitan_after_sales/:id',
    name: 'jushuitan_after_sales.show',
    component: JushuitanAfterSales,
    props: {
      type: 'show',
    }
  },
  {
    path: '/jushuitan_after_sales/:id/edit',
    name: 'jushuitan_after_sales.edit',
    component: JushuitanAfterSales,
    props: {
      type: 'edit'
    }
  }
]
</script>
